<script>
import styler, {templateStyle} from '../styler';
import { markdown } from '../util';

export let title;
export let subtitle;
export let style;
</script>

<div class="section-box col vcenter" use:styler={templateStyle(style)}>
  <div class="title">{title}</div>
  {#if subtitle}
    <div class="sub-title subtitle">{@html markdown(subtitle)}</div>
  {/if}
</div>

<style lang='scss'>
@import '../util';

.section-box {
  padding: 32px 64px;
  // min-height: 200px;
  // padding-bottom: 48px;
  margin-bottom: 32px;
  color: var(--text-primary);
  background: var(--primary);
  /* background-image: url('/img/asset-library-header.jpg'); */
  background-position: center;
  background-size: cover;

  @include shadow;

  @include mobile {
    padding: 16px;
  }
}

.title {
  font-size: 40px;
  font-weight: 800;
  // text-shadow: #00000073 0px 0px 17px;

  @include mobile {
    font-size: 20px;
  }
}

.sub-title {
  margin-top: 16px;
}
</style>